<script setup>
  import { defineProps, computed } from 'vue'
  const props = defineProps({
    labelKey: String,
    inputClass: String,
    vertical: {
      type: Boolean,
      default: false
    },
    verticalBreak: {
      type: String,
      default: 'md'
    },
    colourClass: {
      type: String,
      default: 'gray-300'
    },
    labelClass: {
      type: String,
      default: ''
    },
  })

  const darkColourClass = computed(()=>{
    if (props.colourClass == "gray-300"){
      return "gray-600"
    }
    return props.colourClass
  })
</script>
<template>
  <div :class="[
    'input-group',
    'flex flex-col',
    props.vertical ? '' : props.verticalBreak+':flex-row text-sm '+props.verticalBreak+':text-base',
    'justify-stretch items-stretch shadow border border-'+props.colourClass+' dark:border-'+darkColourClass+' rounded overflow-hidden'
  ]">
    <label :for="props.labelKey" :class="'bg-'+props.colourClass+' dark:bg-'+darkColourClass+' px-4 py-2 '+props.labelClass">
      <slot name="label"/>
    </label>
    <component
      :is="child"
      v-for="(child, i) in $slots.input()"
      :key="i"
      :class="['grow', props.inputClass]"
      :id="i==0 ? props.labelKey : ''"
    />
  </div>
</template>
